<template>
  <div class="container-fluid">
    <mdb-container>
      <mdb-row>
        <mdb-card-title>
          <strong> Add or Remove Users</strong>
        </mdb-card-title>
      </mdb-row>

      <mdb-row>
        <UsersConfig />
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import UsersConfig from "@/components/UsersConfig";
import { mdbCardTitle, mdbRow, mdbContainer } from "mdbvue";

export default {
  name: "Stations",
  components: {
    UsersConfig,
    mdbCardTitle,
    mdbRow,
    mdbContainer,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
